import { Component, ViewEncapsulation } from '@angular/core';
import { Informes } from '../../models/informes.model';
import { TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Router, RouterLink } from '@angular/router';
import { InputNumber } from "primeng/inputnumber";
import { DataService } from '../../services/data';
import { Subscription, combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MessageModule } from 'primeng/message';
import { PreInformeService } from '../../services/preinforme.service';
import { GuardarPreInformeDto, PreInformeDoc, PreInformeItem } from '../../models/preinforme.model';
import { ToastModule } from 'primeng/toast';
import { ToastService } from '../../services/toast.service';
import { Member } from '../../models/member.model';
import { Funciones } from '../../services/funciones';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DatePickerModule } from 'primeng/datepicker';
import { TooltipModule } from 'primeng/tooltip';
import { LanguageService } from '../../services/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MissionCurrencyService } from '../../services/mission-currency.service';
import { resolveCurrencyLocale } from '../../utils/currency.util';
import {
  HISTORIAL_UI_INITIAL,
  historialHasMore,
  nextHistorialVisibleCount,
} from '../../utils/historial.util';

interface HistorialCambioView {
  fecha: string;
  byName: string;
  action: 'create' | 'update';
  resumen?: string;
  campos?: string[];
}

@Component({
  selector: 'app-report-prev',
  imports: [TableModule, ToggleButtonModule, CommonModule, ReactiveFormsModule, FormsModule, ButtonModule, InputNumber, MessageModule, ToastModule, TextareaModule, ToggleSwitchModule, DialogModule, FloatLabelModule, DatePickerModule, RouterLink, TranslateModule, TooltipModule],
  templateUrl: './report-prev.html',
  styleUrl: './report-prev.css',
  encapsulation: ViewEncapsulation.None,
})
export class ReportPrev {

  private subscriptions = new Subscription();
  moneda: string = 'EUR';
  currencyCode = 'EUR';
  currencyLocale = 'es-ES';
  timeZone?: string;

  members: Member[] = [];
  // Variables para el conteo de miembros
  miembrosBautizadosActivos: number = 0;
  hombresCount: number = 0;
  mujeresCount: number = 0;
  familiasCount: number = 0;
  inactivosCount: number = 0;
  activosCount: number = 0;
  bautizadosCount: number = 0;
  noBautizadosCount: number = 0;
  visitantesCount: number = 0;
  miembrosCount: number = 0;
  total: number = 0;

  dataPre: PreInformeItem | null = null;

  informeObreoOptions: Informes[] = this.getDefaultObrero();
  informeFinancieroEgresosB2Options: Informes[] = this.getDefaultEgresosB2();
  informeEspiritualOptions: Informes[] = this.getDefaultEspiritual();

  private informeConfigDinamico: any = null;


  showBanner: boolean = false;
  movementsBlocked = false;
  openPeriodsDisplay = '';
  previousMonthName: string = '';
  /** Periodo del informe abierto (mismo criterio que el banner), solo lectura en cabecera. Ej.: ABRIL-2026 */
  openInformeMesAnio: string = '';

  saving: boolean = false;
  saveSuccess: boolean = false;
  saveMessage: string = '';
  private churchId: string | null = null;
  public textBtn: string = 'REPORT_PREV.BTN_SAVE';

  cambiosDetectados: boolean = false;
  private primeraCarga = true;
  preInforme: PreInformeDoc | null = null;
  preInformeOriginal: PreInformeDoc | null = null;
  private ultimaComparacion: string = '';
  observaciones: any;
  checkedEspiritual: boolean = false;

  /** Historial embebido del pre-informe — solo Pastor/Admin */
  canViewLogs = false;
  historialDialogVisible = false;
  historialEntries: HistorialCambioView[] = [];
  historialVisibleCount = HISTORIAL_UI_INITIAL;

  monthDialog = false;
  selectedMonth: Date | null = null;

  constructor(
    private router: Router,
    private dataService: DataService,
    private preInformeService: PreInformeService,
    private toast: ToastService,
    private funciones: Funciones,
    public languageService: LanguageService,
    private translate: TranslateService,
    private readonly missionCurrency: MissionCurrencyService,
  ) { }

  ngOnInit() {
    this.subscriptions.add(
      this.missionCurrency.currencyCode$.subscribe((code) => {
        this.currencyCode = code;
        this.moneda = code;
        const lang = this.languageService.getCurrentLang() === 'it' ? 'it' : 'es';
        this.currencyLocale = resolveCurrencyLocale(code, lang);
      })
    );
    this.suscripciones();
  }


  suscripciones() {

    this.subscriptions.add(
      this.dataService.openPeriodo$.subscribe(periodo => {
        const ym = (periodo?.id || '').trim();
        if (/^\d{4}-\d{2}$/.test(ym)) {
          const name = this.funciones.formatYMtoText(ym);
          this.previousMonthName = name;
          this.openInformeMesAnio = name.toLocaleUpperCase('es');
        } else {
          this.previousMonthName = '';
          this.openInformeMesAnio = '';
        }
      })
    );

    this.subscriptions.add(
      this.dataService.banner$.subscribe(show => {
        this.showBanner = show;
      })
    );

    this.subscriptions.add(
      this.dataService.periodosFinancierosState$.subscribe(state => {
        this.movementsBlocked = state.movementsBlocked;
        this.openPeriodsDisplay = state.openYms
          .map(ym => this.funciones.formatYMtoText(ym))
          .join(', ');
      })
    );

    this.subscriptions.add(
      this.dataService.churchId$.subscribe(id => {
        this.churchId = id;
      })
    );

    this.subscriptions.add(
      this.dataService.userRoles$.subscribe(roles => {
        this.canViewLogs = (roles ?? []).some((role: string) => ['Pastor', 'Admin'].includes(role));
      })
    );

    this.subscriptions.add(
      this.dataService.members$.subscribe(members => {
        this.members = members;
      })
    );

    this.subscriptions.add(
      this.dataService.preInforme$.subscribe(doc => {
        this.preInforme = doc;
        this.llenarDesdeDoc(doc, true); // true = viene desde Firestore
      })
    );

    this.subscriptions.add(
      this.dataService.informeConfig$.subscribe(config => {
        this.informeConfigDinamico = config;

        // Aplica configuración si no hay documento (primera vista sin crear)
        if (!this.preInforme) {
          const protegidos = ['EG-B1-SUB', 'EG-B2-SUB', 'EG-B2-DP', 'EG-B2-TOTAL', 'BAL-ING-TOT', 'BAL-EGR-TOT', 'BAL-SAL-MES', 'BAL-SAL-ANT', 'BAL-FINAL'];
          this.informeEspiritualOptions = this.getDefaultEspiritual();
          this.informeObreoOptions = this.informeConfigDinamico?.obrero ? this.dataService.fusionarOpcionesInformes(this.getDefaultObrero(), this.informeConfigDinamico.obrero, protegidos) : this.getDefaultObrero();
          this.informeFinancieroEgresosB2Options = this.informeConfigDinamico?.egresosB2 ? this.dataService.fusionarOpcionesInformes(this.getDefaultEgresosB2(), this.informeConfigDinamico.egresosB2, protegidos) : this.getDefaultEgresosB2();
        } else {
          // Si ya existe preInforme, la carga la hace llenarDesdeDoc()
          this.llenarDesdeDoc(this.preInforme, false);
        }
      })
    );
  }

  private getDefaultEspiritual(): Informes[] {
    return [
      { item: 'IE-01', codigo: 'IE-01', descripcion: 'Miembros bautizados activos', valor: 0 },
      { item: 'IE-02', codigo: 'IE-02', descripcion: 'Creyentes bautizados no reconocidos', valor: 0 },
      { item: 'IE-03', codigo: 'IE-03', descripcion: 'Nuevos creyentes', valor: 0 },
      { item: 'IE-04', codigo: 'IE-04', descripcion: 'Miembros bautizados en Espíritu Santo', valor: 0 },
      { item: 'IE-05', codigo: 'IE-05', descripcion: 'Profesiones de fe durante el mes', valor: 0 },
      { item: 'IE-06', codigo: 'IE-06', descripcion: 'Promedio asistencia Escuela Dominical', valor: 0 }
    ];
  }

  private getDefaultObrero(): Informes[] {
    return [
      { item: 'OB-01', codigo: 'OB-01', descripcion: 'Efectuó culto misionero', valor: '' },
      { item: 'OB-02', codigo: 'OB-02', descripcion: 'Efectuó culto Santa Cena', valor: '' },
      { item: 'OB-03', codigo: 'OB-03', descripcion: 'Asistió a culto confraternidad', valor: '' },
      { item: 'OB-04', codigo: 'OB-04', descripcion: 'Recibió visita del presbítero', valor: '' },
      { item: 'OB-05', codigo: 'OB-05', descripcion: 'Efectuó visitas', valor: '' },
      { item: 'OB-06', codigo: 'OB-06', descripcion: 'Realizó evangelismo', valor: '' },
      { item: 'OB-07', codigo: 'OB-07', descripcion: 'Ha fundado campos blancos', valor: '' },
      { item: 'OB-08', codigo: 'OB-08', descripcion: 'Ha formado obreros', valor: '' },
      { item: 'OB-09', codigo: 'OB-09', descripcion: 'Efectúa ayuda social', valor: '' },
      { item: 'OB-10', codigo: 'OB-10', descripcion: 'Efectuó ayuno', valor: '' }
    ];
  }

  private getDefaultEgresosB2(): Informes[] {
    return [
      { item: 'EG-B2-02', codigo: 'EG-B2-03', descripcion: 'Ofrenda Pro-convención', valor: '' },
      { item: 'EG-B2-04', codigo: 'EG-B2-05', descripcion: 'Cuota FEREDE', valor: '' },
      { item: 'EG-B2-05', codigo: 'EG-B2-06', descripcion: 'Gestor', valor: '' },
      { item: 'EG-B2-07', codigo: 'EG-B2-08', descripcion: 'Otras ofrendas y pagos', valor: '' },
      { item: 'EG-B2-09', codigo: 'EG-B2-10', descripcion: 'Seguro de Vida', valor: '' },
      { item: 'EG-B2-10', codigo: 'EG-B2-11', descripcion: 'Seguro defunción', valor: '' },
      { item: 'EG-B2-11', codigo: 'EG-B2-12', descripcion: 'I.R.P.F.', valor: '' },
      { item: 'EG-B2-12', codigo: 'EG-B2-13', descripcion: 'Pago Sistema Informe', valor: 5 },
      { item: 'EG-B2-15', codigo: 'EG-B2-15', descripcion: 'Pago Préstamo', valor: '' },
      { item: 'EG-B2-16', codigo: 'EG-B2-16', descripcion: 'Ofrenda Valdepeñas', valor: '' },
      { item: '*', codigo: 'EG-B2-DP', descripcion: 'Diezmos del pastor', valor: '' }
    ];
  }

  private sumarMiembros(): void {
    const miembrosBautizadosActivos = this.members.filter(member => member.bautismo === 'Bautizado' && member.estadoParticipacion === 'Activo').length;
    const bautizadosNoReconocidos = this.members.filter(member => member.bautismo === 'Bautizado' && member.estadoParticipacion === 'No Reconocido').length;
    const nuevoCreyente = this.members.filter(member => member.tipo === 'Nuevo Creyente').length;
    const bautizadoEspirituSanto = this.members.filter(member => member.bautismoEspirituSanto === 'Sí').length;


    this.setInforme('IE-01', miembrosBautizadosActivos);
    this.setInforme('IE-02', bautizadosNoReconocidos);
    this.setInforme('IE-03', nuevoCreyente);
    this.setInforme('IE-04', bautizadoEspirituSanto);
  }

  llenarDesdeDoc(preOrChecked: PreInformeDoc | null | boolean = this.preInforme, fromFirestore: boolean = false) {
    // Si se llamó desde (ngModelChange) con un booleano (toggle), actualizamos checkedEspiritual
    let pre: PreInformeDoc | null;
    if (typeof preOrChecked === 'boolean') {
      this.checkedEspiritual = preOrChecked;
      pre = this.preInforme;
    } else {
      pre = preOrChecked ?? this.preInforme;
      // Si es la primera carga, guardamos el original
      if (!this.preInformeOriginal && !fromFirestore) {
        this.preInformeOriginal = pre ? JSON.parse(JSON.stringify(pre)) : null;
      }
      // Si el documento trae el flag, lo respetamos (primera carga normalmente)
      this.checkedEspiritual = pre?.checkedEspiritual ?? this.checkedEspiritual;
    }

    const items = pre?.items ?? [];
    const byCode = new Map(items.filter(i => i.codigo).map(i => [this.norm(i.codigo!), i]));
    const byDesc = new Map(items.map(i => [this.norm(i.descripcion), i]));

    // Buscar el item de observaciones por código
    const obsItem = byCode.get('obs-general');
    if (obsItem) {
      const valor = obsItem.valor;
      this.observaciones = typeof valor === 'string' ? this.normalizeObservacionesText(valor) : (valor ?? '');
    } else if (typeof pre?.observaciones === 'string') {
      this.observaciones = this.normalizeObservacionesText(pre.observaciones);
    } else {
      this.observaciones = '';
    }

    const protegidos = ['EG-B1-SUB', 'EG-B2-SUB', 'EG-B2-DP', 'EG-B2-TOTAL', 'BAL-ING-TOT', 'BAL-EGR-TOT', 'BAL-SAL-MES', 'BAL-SAL-ANT', 'BAL-FINAL'];

    // Defaults fusionados dinámicamente 
    const defaultObreroDin = this.informeConfigDinamico?.obrero ? this.dataService.fusionarOpcionesInformes(this.getDefaultObrero(), this.informeConfigDinamico.obrero, protegidos) : this.getDefaultObrero();
    const defaultEgresosB2Din = this.informeConfigDinamico?.egresosB2 ? this.dataService.fusionarOpcionesInformes(this.getDefaultEgresosB2(), this.informeConfigDinamico.egresosB2, protegidos) : this.getDefaultEgresosB2();

    // Filtrar items que no se muestran en pre-informe: EG-B2-01, EG-B2-02 y los que tengan mostrarEnPreInforme === false
    const visibleEgresosB2 = defaultEgresosB2Din.filter(opt =>
      !['EG-B2-01', 'EG-B2-02'].includes(opt.codigo ?? '') &&
      (opt.mostrarEnPreInforme === undefined || opt.mostrarEnPreInforme === true)
    );

    this.informeFinancieroEgresosB2Options = visibleEgresosB2.map(opt => {
      const hit = (opt.codigo && byCode.get(this.norm(opt.codigo))) || byDesc.get(this.norm(opt.descripcion));
      const v = hit?.valor;
      const fixedVal = opt.esLecturaSolo ? this.toNumberValue(opt.valor as any) : undefined;

      if (opt.codigo === 'EG-B2-13' && (v === undefined || v === null || v === '')) {
        return { ...opt, valor: 5 };
      }

      if (typeof fixedVal === 'number' && fixedVal > 0) {
        // valorFijo de Settings/finanzas: siempre tiene prioridad (campo readonly)
        return { ...opt, valor: fixedVal };
      }

      return { ...opt, valor: v !== undefined ? Number(v) : (opt.valor ?? 0) };
    });

    this.informeObreoOptions = defaultObreroDin.map(opt => {
      const hit = (opt.codigo && byCode.get(this.norm(opt.codigo))) || byDesc.get(this.norm(opt.descripcion));
      const valorGuardado = hit?.valor;
      return { ...opt, valor: valorGuardado !== undefined ? String(valorGuardado) : String(opt.valor ?? '') };
    });

    // Informe espiritual: depende del modo (manual/automático)
    if (!this.checkedEspiritual) {
      // Modo manual: llenar desde items del documento
      this.informeEspiritualOptions = this.informeEspiritualOptions.map(opt => {
        const hit = (opt.codigo && byCode.get(this.norm(opt.codigo))) || byDesc.get(this.norm(opt.descripcion));
        const v = hit?.valor;
        return { ...opt, valor: v !== undefined ? Number(v) : (opt.valor ?? 0) };
      });
    } else {
      // Modo automático: calcular algunos valores desde miembros y solo copiar los que vienen del doc cuando aplica
      const promedioAsistenciaED = items.find(i => i.codigo === 'IE-06')?.valor || 0;
      const ProfesionesFe = items.find(i => i.codigo === 'IE-05')?.valor || 0;
      this.setInforme('IE-06', Number(promedioAsistenciaED));
      this.setInforme('IE-05', Number(ProfesionesFe));
      this.sumarMiembros();
    }

    // Si viene desde Firestore, actualizar el original DESPUÉS de procesar todos los datos
    // y NO hacer la comparación de cambios
    if (fromFirestore) {
      this.preInformeOriginal = pre ? JSON.parse(JSON.stringify(pre)) : null;
      this.cambiosDetectados = false; // No hay cambios locales cuando viene de Firestore
      this.textBtn = 'REPORT_PREV.BTN_SAVE';
      this.ultimaComparacion = this.snapshotEditableState();
    } else {
      // Solo evaluar cambios si NO viene de Firestore (es decir, es una edición local)
      this.cambiosDetectados = this.hayCambiosEnPreInforme(this.preInformeOriginal);
      this.textBtn = this.cambiosDetectados ? 'REPORT_PREV.BTN_SAVE_NEW' : 'REPORT_PREV.BTN_SAVE';
      this.ultimaComparacion = this.snapshotEditableState();
    }
  }

  ngDoCheck() {
    // Serializa los datos editables para comparar si han cambiado
    const actual = this.snapshotEditableState();
    if (actual !== this.ultimaComparacion) {
      this.cambiosDetectados = this.hayCambiosEnPreInforme(this.preInformeOriginal);
      if (this.cambiosDetectados) {
        this.textBtn = 'REPORT_PREV.BTN_SAVE_NEW';
      } else {
        this.textBtn = 'REPORT_PREV.BTN_SAVE';
      }
      this.ultimaComparacion = actual;
    }
  }

  private norm(s: string) {
    return (s ?? '').toString().trim().toLowerCase().replace(/\s+/g, ' ');
  }

  private buildItems(): PreInformeItem[] {
    const sanitizeString = (value: any, fallback = '') => String(value ?? fallback).trim();

    const toNumericItem = (x: Informes, categoria?: string): PreInformeItem => ({
      item: sanitizeString(x.item),
      descripcion: sanitizeString(x.descripcion),
      valor: this.toNumberValue(x.valor),
      codigo: sanitizeString(x.codigo) || 'N/A',
      categoria,
      activo: true,
    });

    const toTextItem = (x: Informes, categoria?: string): PreInformeItem => ({
      item: sanitizeString(x.item),
      descripcion: sanitizeString(x.descripcion),
      valor: String(x.valor ?? ''),
      codigo: sanitizeString(x.codigo) || 'N/A',
      categoria,
      activo: true,
    });

    return [
      ...this.informeFinancieroEgresosB2Options.map(x => toNumericItem(x, 'B2')),
      ...this.informeObreoOptions.map(x => toTextItem(x, 'Obrero')),
      ...this.informeEspiritualOptions.map(x => toNumericItem(x, 'Espiritual')),
      ...this.buildObservacionesItems()
    ];
  }

  private toNumberValue(value: number | string | null | undefined): number {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : 0;
    }

    if (typeof value === 'string') {
      const normalized = value.replace(/,/g, '.').trim();
      if (!normalized) {
        return 0;
      }
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    if (typeof value === 'boolean') {
      return value ? 1 : 0;
    }

    return 0;
  }

  private toTextValue(value: number | string | null | undefined): string {
    if (typeof value === 'string') {
      return value.trim();
    }

    if (typeof value === 'number') {
      return Number.isFinite(value) ? String(value) : '';
    }

    return '';
  }

  onObreroToggle(product: Informes, value: boolean): void {
    // Convertir boolean del toggle a string para Firestore
    product.valor = value ? '0' : '';

    // Forzar detección de cambios manualmente
    const hayCambios = this.hayCambiosEnPreInforme(this.preInformeOriginal);

    this.cambiosDetectados = hayCambios;
    this.textBtn = this.cambiosDetectados ? 'Guardar Nuevos Cambios' : 'Guardar';
    this.ultimaComparacion = this.snapshotEditableState();
  }

  async guardarPredefinidos() {
    const items = this.buildItems();
    const observacionesTexto = this.getObservacionesTexto();
    const payload: GuardarPreInformeDto = {
      churchId: this.churchId,
      items,
      moneda: this.missionCurrency.getCurrencyCode(),
      checkedEspiritual: this.checkedEspiritual,
      observaciones: observacionesTexto,
    };
    this.saving = true;
    try {
      const res = await this.preInformeService.guardarPreInforme(payload);
      this.toast.showSuccess(this.translate.instant('REPORT_PREV.TOAST_SAVE_OK'));
      // Actualiza el original y permite seguir editando
      this.preInformeOriginal = {
        ...(this.preInformeOriginal || {}),
        ...payload,
        items: JSON.parse(JSON.stringify(items))
      };
      this.cambiosDetectados = false;
      this.textBtn = 'REPORT_PREV.BTN_SAVE';
      this.ultimaComparacion = this.snapshotEditableState();
    } catch (e: any) {
      this.toast.showError(this.translate.instant('REPORT_PREV.TOAST_SAVE_ERR'));
    } finally {
      this.saving = false;
    }
  }

  verInforme() {
    this.router.navigate(['/dashboard/preview-report']);
  }

  private setInforme(codigo: string, valor: number) {
    const it = this.informeEspiritualOptions.find(x => x.codigo === codigo);
    if (it) it.valor = valor;
  }

  getItemLabel(descripcion: string, codigo?: string): string {
    return this.languageService.getItemLabel(codigo, descripcion);
  }

  private hayCambiosEnPreInforme(preInforme: PreInformeDoc | null): boolean {
    if (!preInforme) return false;

    const itemsGuardadosArray = Array.isArray(preInforme.items) ? preInforme.items : [];

    // Convierte los items guardados en un Map para comparación rápida
    const itemsGuardados = new Map(
      itemsGuardadosArray.map(i => [this.norm(i.codigo || i.descripcion), i.valor])
    );

    // Une todos los items actuales
    const itemsActuales = [
      ...this.informeFinancieroEgresosB2Options,
      ...this.informeObreoOptions,
      ...this.informeEspiritualOptions,
      ...this.buildObservacionesItems()
    ];

    const actualKeys = new Set<string>();

    for (const actual of itemsActuales) {
      const key = this.norm(actual.codigo || actual.descripcion);
      actualKeys.add(key);
      const valorGuardado = itemsGuardados.get(key);

      if (key.startsWith('ob-')) {
        const normGuardado = this.normalizeComparableValue(valorGuardado, 'boolean');
        const normActual = this.normalizeComparableValue(actual.valor, 'boolean');
        if (normActual !== normGuardado) {
          return true;
        }
        continue;
      }

      const tipoEsperado = typeof actual.valor !== 'undefined'
        ? typeof actual.valor
        : (typeof valorGuardado !== 'undefined' ? typeof valorGuardado : 'string');
      const normActual = this.normalizeComparableValue(actual.valor, tipoEsperado);
      const normGuardado = this.normalizeComparableValue(valorGuardado, tipoEsperado);
      if (normActual !== normGuardado) {
        return true;
      }
    }

    for (const key of itemsGuardados.keys()) {
      if (!actualKeys.has(key)) {
        return true;
      }
    }

    const obsGuardadas = this.normalizeComparableValue(preInforme.observaciones, 'string');
    const obsActual = this.normalizeComparableValue(this.observaciones, 'string');

    if (obsGuardadas !== obsActual) {
      return true;
    }

    return false; // No hay diferencias
  }

  consultarInformesAnteriores() {
    const month = this.selectedMonth?.getMonth()! + 1;
    const year = this.selectedMonth?.getFullYear();
    const periodo = `${year}-${month.toString().padStart(2, '0')}`;
    this.monthDialog = false;
    // Navega al componente reports-old y pasa churchId y periodo como parámetros
    if (this.churchId && periodo) {
      this.router.navigate(['/dashboard/reports-old'], {
        queryParams: {
          churchId: this.churchId,
          periodo: periodo
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private buildObservacionesItems(): PreInformeItem[] {
    if (!this.observaciones) {
      return [];
    }

    if (Array.isArray(this.observaciones)) {
      return this.observaciones
        .filter((obs: any) => obs && (obs.descripcion || obs.valor))
        .map((obs: any, index: number) => ({
          item: String(obs.item || `OBS-${index + 1}`).trim(),
          codigo: String(obs.codigo || `OBS-${index + 1}`).trim(),
          descripcion: String(obs.descripcion || `Observación ${index + 1}`).trim(),
          valor: typeof obs.valor === 'string' ? this.normalizeObservacionesText(obs.valor) : (typeof obs.valor === 'undefined' ? '' : obs.valor),
          categoria: 'Observaciones',
          activo: true,
        }));
    }

    if (typeof this.observaciones === 'string') {
      const texto = this.normalizeObservacionesText(this.observaciones);
      if (!texto) {
        return [];
      }
      return [{
        item: 'OBS-GENERAL',
        codigo: 'OBS-GENERAL',
        descripcion: 'Observaciones generales',
        valor: texto,
        categoria: 'Observaciones',
        activo: true,
      }];
    }

    return [];
  }

  private getObservacionesTexto(): string | undefined {
    if (typeof this.observaciones === 'string') {
      const texto = this.normalizeObservacionesText(this.observaciones);
      return texto || undefined;
    }
    return undefined;
  }

  private normalizeObservacionesText(value: any): string {
    if (typeof value !== 'string') {
      return '';
    }
    return value.replace(/\r\n/g, '\n').trim();
  }

  private normalizeComparableValue(value: any, expectedType: string): string {
    if (expectedType === 'number') {
      const coerced = typeof value === 'number' ? value : Number(value ?? 0);
      if (!Number.isFinite(coerced)) {
        return '0';
      }
      return coerced.toString();
    }

    if (expectedType === 'boolean') {
      if (typeof value === 'string') {
        const normalized = value.trim();
        // En Firestore: '0' = true/SI, '' = false/NO
        return normalized === '0' ? 'true' : 'false';
      }
      return value ? 'true' : 'false';
    }

    if (typeof value === 'string') {
      return this.normalizeObservacionesText(value);
    }

    if (value === undefined || value === null) {
      return '';
    }

    if (Array.isArray(value) || typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch {
        return '';
      }
    }

    return String(value);
  }

  private snapshotEditableState(): string {
    return JSON.stringify([
      this.informeFinancieroEgresosB2Options,
      this.informeObreoOptions,
      this.informeEspiritualOptions,
      this.normalizeComparableValue(this.observaciones, 'string')
    ]);
  }

  openHistorial(): void {
    const source = this.preInforme;
    const entries: any[] = Array.isArray(source?.historialCambios) ? source!.historialCambios! : [];

    this.historialEntries = entries
      .map((entry) => ({
        fecha: this.formatHistorialFecha(entry?.at),
        byName: entry?.byName || source?.updatedByName || source?.createdByName || '—',
        action: entry?.action === 'create' ? 'create' : 'update',
        resumen: entry?.resumen || undefined,
        campos: Array.isArray(entry?.campos) ? entry.campos : undefined,
      } as HistorialCambioView))
      .reverse();

    this.historialVisibleCount = HISTORIAL_UI_INITIAL;
    this.historialDialogVisible = true;
  }

  get visibleHistorialEntries(): HistorialCambioView[] {
    return this.historialEntries.slice(0, this.historialVisibleCount);
  }

  get hasMoreHistorialEntries(): boolean {
    return historialHasMore(this.historialVisibleCount, this.historialEntries.length);
  }

  loadMoreHistorial(): void {
    this.historialVisibleCount = nextHistorialVisibleCount(
      this.historialVisibleCount,
      this.historialEntries.length
    );
  }

  closeHistorial(): void {
    this.historialDialogVisible = false;
    this.historialEntries = [];
    this.historialVisibleCount = HISTORIAL_UI_INITIAL;
  }

  get historialCreatedByName(): string {
    return this.preInforme?.createdByName || '—';
  }

  get historialUpdatedByName(): string {
    return this.preInforme?.updatedByName || this.preInforme?.createdByName || '—';
  }

  private formatHistorialFecha(value: any): string {
    if (!value) return '—';
    let date: Date | null = null;
    if (typeof value?.toDate === 'function') {
      date = value.toDate();
    } else if (typeof value?.seconds === 'number') {
      date = new Date(value.seconds * 1000);
    } else if (value instanceof Date) {
      date = value;
    } else if (typeof value === 'string' || typeof value === 'number') {
      const parsed = new Date(value);
      if (!isNaN(parsed.getTime())) date = parsed;
    }
    if (!date) return '—';
    const lang = this.translate.getCurrentLang() || 'es';
    const locale = lang === 'it' ? 'it-IT' : 'es-ES';
    return date.toLocaleString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
